import { render, staticRenderFns } from "./VContainer.vue?vue&type=template&id=9fcb3dd4&scoped=true&"
import script from "./VContainer.vue?vue&type=script&lang=js&"
export * from "./VContainer.vue?vue&type=script&lang=js&"
import style0 from "./VContainer.vue?vue&type=style&index=0&id=9fcb3dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcb3dd4",
  null
  
)

export default component.exports